import { mapGetters } from 'vuex';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import brokerageNearby from '@/agent/components/brokeragenearby/brokerage-nearby.vue';
import brokerageAgent from '@/agent/components/brokerageagent/brokerage-agent.vue';
import brokerageBanner from '@/agent/components/brokeragebanner/brokerage-banner.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import agentRegion from '@/agent/components/agentregion/agent-region.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pageAgentHome',
    inject: ['$eventBus'],
    components: {
        mvtDialogCenter,
        agentRegion,
        mvtWelcome,
        brokerageAgent,
        brokerageNearby,
        brokerageBanner,
        mvtNearby,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('agents', ['brokerage']),
    },
    methods: {
        completedNearbyCity() {
            this.$refs.lazyloadNearbyCity.ready();
        },
    },
};
